import { render, staticRenderFns } from "./LoaderModal.vue?vue&type=template&id=54a91a13&scoped=true"
import script from "./LoaderModal.vue?vue&type=script&lang=js"
export * from "./LoaderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a91a13",
  null
  
)

export default component.exports